import { render, staticRenderFns } from "./userAttrs.vue?vue&type=template&id=ca24abfe&scoped=true&"
import script from "./userAttrs.vue?vue&type=script&lang=js&"
export * from "./userAttrs.vue?vue&type=script&lang=js&"
import style0 from "./userAttrs.vue?vue&type=style&index=0&id=ca24abfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca24abfe",
  null
  
)

export default component.exports